// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JvWH5","placeholdersHeader":"styles_placeholdersHeader__3Pgtd","editorStyle":"styles_editorStyle__25lLE","placeholdersBox":"styles_placeholdersBox__g8AUi"};